import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    template: 'default',
    logo: {
        logoType: 'logo',
        logoPath: '',
        faviconPath: '',
        faviconGenerated: false,
        faviconFontFamily: '',
        logoText:'',
        slogan:'',
        size: 'medium', // small | medium | large
    },
    colors: {
        primary: '#000000',
        secondary: '#ffffff',
        tertiary: '#000000',
        quaternary: '#ff0000',
        headings: '#000000',
        body: '#ffffff',
    },
    typography: {
        headings: 'Poppins',
        body: 'Poppins',
        baseSize: 'medium', // small (14px) | medium (16px) | large (18px)
        headingSize: 'medium', // small (24px) | medium (32px) | large (40px) | xlarge (48px)
        buttonSize: 'medium', // small (12px) | medium (14px) | large (16px)
    },
    buttons: {
        primary: '#000000',
        hover: '#000000',
        borderRadius: 5,
    },
    layout: {
        productGridColumns: 4, // 2 | 3 | 4 | 5
    },
    banners: {
        numberOfBanners: 0,
        items: [],
        // items structure: [{ id, title, subtitle, description, buttonText, buttonLink, imageUrl, gradient, badge, offer }]
    },
    preOrderBadgeType: 'normal',
    disclaimer: {
        termsAndConditions:'',
        privaryPolicy:'',
        shippingPolicy:'',
        returnsAndExchange:'',
        faqs:''
    },
    topBar:{
        showTopBar: true,
        leftSectionIcon:'AddShoppingCart',
        leftSectionText:'Free shipping for Order of KES 10,000.00',
        middleSectionIcon:'Redeem',
        middleSectionText:'We have restocked! Get your order today.',
    },
    socialMedia:{
        facebook:'',
        instagram:'',
        x:'',
        linkedIn:'',
        tikTok:'',
    },
    trustBadges: {
        enabled: false,
        items: [], // [{ id, icon, title, subtitle }] — icon is a MUI icon name
    },
    testimonials: {
        enabled: false,
        items: [], // [{ id, name, location, rating, comment, avatarUrl }]
    },
    fanCommunity: {
        enabled: false,
        title: '',
        subtitle: '',
        hashtag: '',
        stats: [], // [{ label, value }]
        posts: [], // [{ id, imageUrl, handle, location, platform }]
    },
    workingHours: {
        enabled: false,
        lines: [], // [{ label, value }]
    },
};

const templateSlice = createSlice({
    name: 'template',
    initialState,
    reducers: {
        setTemplate(state, action) {
            state.template = action.payload;
        },
        setLogo(state, action) {
            state.logo = { ...state.logo, ...action.payload };
        },
        setColors(state, action) {
            state.colors = { ...state.colors, ...action.payload };
        },
        setTypography(state, action) {
            state.typography = { ...state.typography, ...action.payload };
        },
        setButtons(state, action) {
            state.buttons = { ...state.buttons, ...action.payload };
        },
        setLayout(state, action) {
            if (action.payload) state.layout = { ...state.layout, ...action.payload };
        },
        setBanners(state, action) {
            state.banners = { ...state.banners, ...action.payload };
        },
        setPreOrderBadgeType(state, action) {
            state.preOrderBadgeType = action.payload;
        },
        setDisclaimer(state, action) {
            state.disclaimer = { ...state.disclaimer, ...action.payload };
        },
        setTopBar(state, action) {
            state.topBar = { ...state.topBar, ...action.payload };
        },
        setSocialMedia(state, action) {
            state.socialMedia = { ...state.socialMedia, ...action.payload };
        },
        setTrustBadges(state, action) {
            if (action.payload) state.trustBadges = { ...state.trustBadges, ...action.payload };
        },
        setTestimonials(state, action) {
            if (action.payload) state.testimonials = { ...state.testimonials, ...action.payload };
        },
        setFanCommunity(state, action) {
            if (action.payload) state.fanCommunity = { ...state.fanCommunity, ...action.payload };
        },
        setWorkingHours(state, action) {
            if (action.payload) state.workingHours = { ...state.workingHours, ...action.payload };
        },
    },
});

export const {
    setTemplate,
    setLogo,
    setColors,
    setTypography,
    setButtons,
    setLayout,
    setBanners,
    setPreOrderBadgeType,
    setDisclaimer,
    setTopBar,
    setSocialMedia,
    setTrustBadges,
    setTestimonials,
    setFanCommunity,
    setWorkingHours,
} = templateSlice.actions;

export default templateSlice.reducer;
